import { useState } from "react";
import { Lock } from "lucide-react";
import { apiLogin, setToken } from "@/admin/adminApi";

const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const res = await apiLogin(email.trim(), password);
      setToken(res.data.token);
      onLogin(res.data.email);
    } catch (err) {
      setError("Incorrect email or password");
    }
    setBusy(false);
  };

  return (
    <div className="admin-login" data-testid="admin-login">
      <form className="admin-login-card" onSubmit={handleSubmit}>
        <span className="admin-login-icon">
          <Lock size={18} />
        </span>
        <h1 className="admin-login-title">Admin Panel</h1>
        <p className="admin-login-sub">Sign in to manage the website</p>
        <label className="af-field">
          <div className="af-field-head">
            <span className="af-label">Email</span>
          </div>
          <input
            className="af-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@company.com"
            data-testid="admin-email-input"
            required
          />
        </label>
        <label className="af-field">
          <div className="af-field-head">
            <span className="af-label">Password</span>
          </div>
          <input
            className="af-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
            data-testid="admin-password-input"
            required
          />
        </label>
        {error && (
          <p className="af-error" data-testid="admin-login-error">{error}</p>
        )}
        <button
          type="submit"
          className="af-btn af-btn-primary admin-login-btn"
          disabled={busy}
          data-testid="admin-login-btn"
        >
          {busy ? "Signing in..." : "Sign In"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;
